import { HourMs, MinuteMs } from 'rev-shared/date/Time.Constant';

export function isTimeToStart(startDate: Date, endDate: Date, lobbyTimeMinutes: number): boolean {
	const t = Date.now();

	return t > calculateStartDate (startDate, lobbyTimeMinutes)
		&& t < endDate.getTime();
}

export function isTimeToStartPreProduction(preProdDurationMs: number, startDate: Date): boolean {
	const t = Date.now();

	return t > calculatePreProdStartDate(startDate, preProdDurationMs)
		&& t < startDate.getTime();
}

export function calculatePreProdStartDate(startDate: Date, preProdDurationMs: number): number {
	return startDate.getTime() - preProdDurationMs;
}

export function calculateStartDate(startDate: Date, lobbyTimeMinutes: number): number {
	return startDate.getTime() - lobbyTimeMinutes * MinuteMs;
}

export function isPastEndDate(endDate: Date, bufferTime: number = HourMs): boolean {
	const t = Date.now();

	return t > endDate.getTime() + bufferTime;
}

export function isBeforeStartDate(startDate: Date, lobbyTimeMinutes: number): boolean {
	const t = Date.now();
	return t < startDate.getTime() - lobbyTimeMinutes * MinuteMs;
}
